import { create } from "zustand";

export const useOrderDebugStore = create((set) => ({
  debugOrders: [],

  addDebugOrder: (event) =>
    set((state) => {
      state.debugOrders.push(event);   // no array copy
      return state;
    }),

  clearDebugOrders: () =>
    set((state) => {
      state.debugOrders = [];
      return state;
    }),
}));